import { render, staticRenderFns } from "./activeDownUp.vue?vue&type=template&id=54cb85aa&scoped=true&"
import script from "./activeDownUp.vue?vue&type=script&lang=js&"
export * from "./activeDownUp.vue?vue&type=script&lang=js&"
import style0 from "./activeDownUp.vue?vue&type=style&index=0&id=54cb85aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cb85aa",
  null
  
)

export default component.exports